import React, { useContext } from "react";

import { TranslationsContext } from "./context/translationsContext";

export default function ResponseLink(props) {
  const translations = useContext(TranslationsContext);
  return (
    <div className="comment-reply-link">
      <button onClick={props.onClick} href={`#${props.commentId}`} rel="nofollow">
        {translations.respondLinkLabel}
      </button>
    </div>
  );
}